import StructuredData from './components/StructuredData';

const applyConfig = (config) => {
  config.settings.appExtras = [
    ...(config.settings.appExtras || []),
    {
      match: '',
      component: StructuredData,
    },
  ];

  // Default: no structured data. Set config.settings.structuredData in your
  // project's addon config to provide the JSON-LD object.
  if (!config.settings.structuredData) {
    config.settings.structuredData = null;
  }

  return config;
};

export default applyConfig;
